module.exports = __webpack_public_path__ + "img/Emergencia_Pediatrica.7843ea61.jpg";